module.exports = __webpack_public_path__ + "static/media/acura-minus.588ebd8e.svg";